import React from "react";
import { Link } from "react-router-dom";
import { logo } from "../../assets";
import "./Logo.css";

const Logo = () => {
  return (
    <div className="flex__center logo__container">
      <Link to="/" className="logo__link" aria-label="Go to homepage">
        <img src={logo} alt="Vision Security" />
      </Link>
    </div>
  );
};

export default Logo;
